import { Canvas, RootState, useFrame } from "@react-three/fiber"
import { OrbitControls } from "@react-three/drei";
import { Stack, Box, SvgIcon } from "@mui/material";
import Loader from "components/Loader"
import { useState, useEffect, useRef, MutableRefObject } from "react";
import { Group, Mesh, Box3, Vector3, BoxGeometry, Euler, Color, SRGBColorSpace, Material, BufferGeometry, NormalBufferAttributes, Object3DEventMap, MeshPhysicalMaterial, MeshBasicMaterial } from "three";
import { ConvexGeometry } from 'three/examples/jsm/geometries/ConvexGeometry.js';
import FreeDrawTool from "components/Viewer3D/components/FreeDrawTool";
import MeasureTool from "components/Viewer3D/components/MeasureTool";
import ZoomController from "components/Viewer3D/components/ZoomController";
import { useNavigate, useSearchParams } from "react-router-dom";
import html2canvas from "html2canvas";


import ModeIcon from '@mui/icons-material/Mode';

import moment from "moment";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";

import BottomBar from "./ui-desk/BottomBar"


import MarmoRealLogoTondo from './ui-logo/MarmoRealLogoTondo'

import { UAParser } from 'ua-parser-js';


import Button from '@mui/material/Button';
import TweenAnim from "./components/TweenAnim";

import NavBarComponent from "./ui-desk/NavBarComponent/NavBarComponent";
import PulsanteReturnSpento from "./ui-mobile/icons/PulsanteReturnSpento";
import PulsanteHelpAcceso from "./ui-mobile/icons/PulsanteHelpAcceso";
import PulsanteHelpSpento from "./ui-mobile/icons/PulsanteHelpSpento";
import PulsanteReset from "./ui-mobile/icons/PulsanteReset";
import PulsanteMenu from "./ui-mobile/icons/PulsanteMenu";
import PulsanteVisibilityOn from "./ui-mobile/icons/PulsanteVisibilityOn";
import PulsanteVisibilityOff from "./ui-mobile/icons/PulsanteVisibilityOff";
import BoxContainer from "./ui-mobile/BoxContainerMobile/BoxContainer";
import LottieInitAnimation from "./ui-components/LottieInitAnimation";
//import DrawButton from "./buttons/DrawButton";
//import MeasureButton from "./buttons/MeasureButton";
import SquareButtonMobile from "./ui-mobile/SquareButtonMobile/SquareButtonMobile";

import PulsanteDrawOn from "./ui-mobile/newIcons/PulsanteDrawAcceso";
import PulsanteDrawOff from "./ui-mobile/newIcons/PulsanteDrawSpento";

import PulsanteRulerOn from "./ui-mobile/newIcons/PulsanteRulerAcceso";
import PulsanteRulerOff from "./ui-mobile/newIcons/PulsanteRulerSpento";

import PulsanteScreenOff from "./ui-mobile/newIcons/PulsanteScreenOff";





interface ModelProps {
  onReady: () => void;
  refModel: MutableRefObject<Mesh>;
  gltfModel: Mesh<
    BufferGeometry<NormalBufferAttributes>,
    Material | Material[],
    Object3DEventMap
  >;
}

function Model(props: ModelProps) {
  const called = useRef(false);
  const { onReady } = props;

  useFrame(() => {
    if (!called.current) {
      called.current = true;
      onReady();
    }
  });

  return (
    <mesh ref={props.refModel} name="base">
      <primitive object={props.gltfModel} />
    </mesh>
  );
}


interface Viewer3DProps {
  height: number;
  width: number;
  modelSrc: string /**the url to the .obj resource */;
  companyLogo?: string;
  modelName: string,
  material: string,
  dimension: string,
  dimInch?: string
}

export default function Viewer3D(props: Viewer3DProps) {

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [isMobile, setMobile] = useState<boolean>(false);
  //const heightDesktop = "8.88vh";
  const heightDesktop = "60px";
  //const heightMobile = "50px";

  const [heightMobile, setHeightMobile] = useState<string>("50px");

  //const refAnchor = useRef<HTMLElement>(null);
  //const refAnchorMobile = useRef<HTMLElement>(null);


  const goBack = () => {
    const returnUrl = searchParams.get("returnUrl");
    if (returnUrl) {
      navigate(returnUrl);
      return;
    }
    navigate(-1);
  };

  const [myState, setState] = useState<boolean>(false);
  const [measure, enableMeasure] = useState<boolean>(false);
  const [measurePending, setPending] = useState<boolean>(false);
  const [freeDraw, enableFreeDraw] = useState<boolean>(false);
  const [stateCanvas, setStateCanvas] = useState<RootState>(null!);
  const [loading, setLoading] = useState<number | boolean>(false);
  const [gltfModel, setGltf] = useState<Mesh>(null!);

  const [renderingDone, setRenderingDone] = useState(false);

  // ad ora queste non sono utilizzate
  //const [freeLine, setFreeLine] = useState<Line2[]>([]);

  const [lineVisible, setLineVisible] = useState<boolean>(true);

  const [initDistance, setInitDistance] = useState<number>(0);


  //const refActiveButton = useRef<HTMLElement>(null!)

  const refInnerBottomBar = useRef<HTMLDivElement>(null);
  const refInnerBottomMenu = useRef<HTMLDivElement>(null);

  /*const updateMeasure = (measure: MeasureType): void => {
    setMeasure(current => [...current, measure]);
  }*/

  /*const modelLoaded = useCallback(() => {
    setState(true);
  }, []) */


  const refGroup = useRef<Group>(null!);
  const refModel = useRef<Mesh>(null!);
  const refBBox = useRef<Mesh>(null!);
  const refConvex = useRef<Mesh>(null!);
  const refControls = useRef<any>(null!);
  const refBox3 = useRef<Box3>(null!);

  const [editRuler, setEditRuler] = useState<boolean>(false);

  const [showHelp, setHelp] = useState<boolean>(false);
  const [showInfo, setInfo] = useState<boolean>(false);
  const [showMenu, setMenu] = useState<boolean>(false);



  useEffect(() => {
    window.createImageBitmap = undefined;
    const loader = new GLTFLoader();
    loader.load(props.modelSrc,
      function (gltf) {
        let model = gltf.scene.children[0] as Mesh;
        let geom = model.geometry;
        let material = model.material as MeshPhysicalMaterial;
        let albedo = material.map;
        albedo.anisotropy = 16;
        let baseModelMaterial = new MeshBasicMaterial({ map: albedo });
        let baseModel = new Mesh(geom, baseModelMaterial);

        setGltf(baseModel);
        setState(true);
        let parser = new UAParser();
        let dev = parser.getDevice()?.type;
        if (dev !== undefined && dev === 'mobile') {
          setMobile(true);
        }

      },
      function (xhr) {
        const completed = Math.floor((xhr.loaded / xhr.total) * 100);
        setLoading(completed == 100 ? false : completed);
      },
      function (error) {
        console.log("Error: ", error);
      }
    )

  }, [])

  function changeVisibilityChildren(mesh: Mesh, visibility: boolean): void {
    mesh.children.forEach((child) => {
      child.visible = visibility
    })
  }

  function setVisibility() {
    if (lineVisible == false) {
      changeVisibilityChildren(refConvex.current, true);
      changeVisibilityChildren(refBBox.current, true);
      setLineVisible(true);
    } else {
      changeVisibilityChildren(refConvex.current, false);
      changeVisibilityChildren(refBBox.current, false);
      setLineVisible(false);
    }
    if (freeDraw) {
      enableFreeDraw(false);
    }

  }

  const makeScreenShot = () => {
    // se disabilito preserveBuffer, devo eseguire
    // il render forzato prima di fare lo screen
    let container = document.createElement("div");
    container.style.position = "relative";
    container.id = "to-clone";
    let sceneImg = document.createElement("img");
    sceneImg.src = stateCanvas.gl.domElement.toDataURL();
    container.appendChild(sceneImg);
    document.body.appendChild(container);
    html2canvas(document.getElementById("to-clone") as HTMLElement, {
      width: stateCanvas.gl.domElement.width,
      height: stateCanvas.gl.domElement.height,
      logging: false
    }).then(
      (canvas) => {
        let a = document.createElement("a");
        a.download = `Marmoreal-screenshot-${moment()}.png`;
        a.href = canvas.toDataURL("image/png");
        a.click();
        document.body.removeChild(
          document.getElementById("to-clone") as HTMLElement
        );
      }
    );
  };

  

  const checkEnableMeasure = () => {
    if (!measure) {
      refControls.current.enabled = false;
      enableMeasure(true);
    } else {
      refControls.current.enabled = true;
      refControls.current.update();
      enableMeasure(false);
    }
    if (freeDraw) {
      enableFreeDraw(false)
    }
  }

  const checkEnableFreeDraw = () => {
    if (!freeDraw) {
      refControls.current.enabled = false;
      enableFreeDraw(true)
    } else {
      refControls.current.enabled = true;
      refControls.current.update();
      enableFreeDraw(false);
    }
    if (measure) {
      enableMeasure(false);
    }
  }

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    }
  }, [])

  const deleteChildren = (mesh: Mesh): void => {
    let children = mesh.children;
    while (children.length > 0) {
      mesh.remove(children[0]);
      children = mesh.children;
    }
  }

  const resetGroup = () => {
    refGroup.current.position.copy(new Vector3(0, 0, 0));
    refGroup.current.children.forEach((child) => {
      child.position.copy(new Vector3(0, 0, 0));
      child.rotation.copy(new Euler(0, 0, 0));
    })
    deleteChildren(refBBox.current);
    deleteChildren(refConvex.current);
    refBBox.current.geometry.computeBoundingBox();
    refBox3.current = new Box3().setFromObject(refBBox.current);
    enableFreeDraw(false);
    setInitPos(new Vector3(0,0,3.5))
  }

  useEffect(() => {
    if (refBBox.current !== null) {
      let box3 = new Box3().setFromObject(gltfModel, true);
      box3.getCenter(gltfModel.position);
      let size = box3.getSize(new Vector3());
      gltfModel.geometry.center();
      gltfModel.updateMatrix();

      //console.log(size)
      const offset = 0.05;
      // creando la box con il flag precise=true,
      // in rari casi puo' accadere che la mesh 
      // del modello e la bbox siano a "pari"
      // vedi test con blocco 11 e 4
      refBBox.current.geometry = new BoxGeometry(size.x + offset, size.y + offset, size.z + offset);
      let points = [];
      let pointGeometry = gltfModel.geometry.attributes.position.array;
      for (let i = 0; i < pointGeometry.length; i += 3) {
        points.push(new Vector3(pointGeometry[i], pointGeometry[i + 1], pointGeometry[i + 2]))
      }
      let cg = new ConvexGeometry(points);
      refConvex.current.geometry = cg;
      refConvex.current.geometry.computeBoundingBox();
      refConvex.current.geometry.boundingBox.getCenter(gltfModel.position);
      refConvex.current.geometry.applyQuaternion(gltfModel.quaternion);
      refConvex.current.updateMatrix();
      refConvex.current.geometry.attributes.position.needsUpdate = true;
      refGroup.current.position.set(0, 0, 0);
      let newBox3: Box3 = new Box3().setFromObject(refBBox.current);
      refBox3.current = newBox3;
      let dist = newBox3.distanceToPoint(stateCanvas.camera.position);
      setInitDistance(dist);

    }
  }, [refBBox.current])

  const [initPos, setInitPos] = useState<Vector3>(new Vector3(0,0,1.5));

  useEffect(() => {
    if (stateCanvas !== null && stateCanvas !== undefined) {
      const { camera } = stateCanvas;
      if (initPos.z == 3.5) {
        camera.position.set(0,0,3.5);
        camera.zoom = 1;
        camera.updateProjectionMatrix();
        refControls.current.update();
      }
    }
  },[initPos]);
  
  
  return gltfModel ? (
    <>
      {!renderingDone ? (
        <>
          {" "}
          <Stack
            sx={{
              position: "fixed",
              top: "50%",
              zIndex: "1202",
              width: "100%",
              justifyContent: "center",
              alignItems: "center",
            }}
            gap={2}
          >
            <Loader /> <span>Rendering..</span>
          </Stack>{" "}
        </>
      ) : null}
      <div
        className="main-canvas-container"
        style={{
          display: "flex",
          position: "absolute",
          top: !isMobile ? heightDesktop : "1.6vh",
          bottom: !isMobile ? "0.83vw" : heightMobile,
          width: "100%",
          padding: !isMobile ? "0px 0.83vw" : "0px 3.72vw"
        }}
      >
        <Canvas
          onCreated={(state) => setStateCanvas(state)}
          gl={{ preserveDrawingBuffer: true, outputColorSpace: SRGBColorSpace, toneMapping: 0 }}
          camera={{ near: 0.01, position: initPos }}
          scene={{ background: new Color(0x808080) }}
          style={{ borderRadius: "40px" }} 
        >
          <TweenAnim onCompleted={() => setInitPos(new Vector3(0,0,3.5))}/>

          <OrbitControls
            ref={refControls}
            zoomSpeed={0.5}
            minZoom={0.8}
            rotateSpeed={0.5}
            minDistance={1}
            maxDistance={8}
            enabled={!(measure || measurePending || freeDraw || editRuler)}
            panSpeed={0.5}
            makeDefault={true}
          />
          <ZoomController
            refToControls={refControls}
            refToMesh={refBox3}
            initDistance={initDistance}
          />
          <FreeDrawTool
            color="red"
            size={2}
            enabled={freeDraw}
            meshName="prova"
            suffix="draw"
            refMesh={refConvex}
          />
          <MeasureTool
            color="red"
            enabled={measure}
            meshName="bbox"
            convexName="convex"
            suffixLabel="measure"
            refToMesh={refBBox}
            refToConvex={refConvex}
            refToBase={refModel}
            sizeLine={2}
            onEndMeasure={enableMeasure}
            editableRuler={setEditRuler}
          />
          <group ref={refGroup}>
            <Model
              gltfModel={gltfModel}
              refModel={refModel}
              onReady={() => {
                setRenderingDone(true);
              }}
            />

            <mesh ref={refBBox} name="bbox">
              <meshBasicMaterial
                color={0xff0000}
                wireframe={true}
                transparent={true}
                opacity={0}
              />
            </mesh>

            <mesh ref={refConvex} name="convex">
              <meshBasicMaterial
                color={0x0000ff}
                wireframe={true}
                transparent={true}
                opacity={0}
              />
            </mesh>
          </group>
        </Canvas>
      </div>
      {!isMobile ? (
        <>
          <NavBarComponent
            dimInch={props.dimInch}
            dimension={props.dimension}
            material={props.material}
            modelName={props.modelName}
            heightDesktop={heightDesktop}
            onReset={resetGroup}
            onGoBack={goBack}
            drawOn={freeDraw}
            measureOn={measure}
            onClickDraw={checkEnableFreeDraw}
            onClickMeasure={checkEnableMeasure}
            onToggleVisibility={setVisibility}
            visibility={lineVisible}
            onTakeScreen={makeScreenShot}
          />
        </>
      ) : (
        <>

          <div
            style={{
              zIndex:1200,
              position:"fixed",
              top: "calc(1.6vh + 16px)",
              left: "calc(3.72vw + 16px)"
            }}
            onClick={() => goBack()}
          >
            <PulsanteReturnSpento />
          </div>

          <div
            style={{
              zIndex:1200,
              position:"fixed",
              top: "calc(1.6vh + 16px)",
              right: "calc(3.72vw + 16px)"
            }}
            onClick={() => setHelp(!showHelp)}
          >
            {!showHelp ? <PulsanteHelpSpento /> : <PulsanteHelpAcceso /> }
          </div>

          <div
            style={{
              zIndex:1200,
              position:"fixed",
              bottom: heightMobile,
              right: "calc(3.72vw + 16px)",
              marginBottom: "16px"
            }}
            onClick={() => setVisibility()}
          >
            {lineVisible ? <PulsanteVisibilityOff /> : <PulsanteVisibilityOn /> }
          </div>



          <BoxContainer
            visible={showHelp}
            position={{ top: "calc(1.6vh + 8px", right: "calc(3.72vw + 8px)", visibility: showHelp ? "visible":"hidden" }}
            titleBox={"Help"}
            titleDescription={["Drag", "Pinch", "Two fingers drag"]}
            description={["Rotation", "Zoom", "Panning"]}
            asInfoBlock={false}
          />
        
          {freeDraw ? (
            <Box
              component={"div"}
              display={"flex"}
              position={"fixed"}
              top={heightMobile}
              paddingBottom={"15px"}
              style={{ width: "100%" }}
              justifyContent={"center"}
              zIndex={"1400"}
              marginTop={1}
            >
              <Button
                disableRipple
                title="Disable free draw"
                sx={{
                  border: 1,
                  borderRadius: "50%",
                  padding: 2,
                  color: "rgba(6,11,12,0.75)",
                }}
                onClick={checkEnableFreeDraw}
                style={{ backgroundColor: "rgba(6,11,12,0.75)" }}
              >
                <ModeIcon sx={{ color: "#4BBECF" }} />
              </Button>
            </Box>
          ) : (
            <></>
          )}

          <BottomBar height={heightMobile}>
            <div
              className="wrapper-inside-bottombar"
              style={{
                display:"flex",
                width: "100%",
                padding: "0px 6.21vw",
                alignContent:"center",
                justifyContent:"space-between",
                height:"50px"
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems:"center"
                }}
                onClick={() => resetGroup()}
              >
                <PulsanteReset />
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems:"end"
                }}
                onClick={() => {
                  // e' un numero puro
                  let childrenH = refInnerBottomBar.current.offsetHeight;
                  if (!showInfo) {
                    setInfo(true);
                    setMenu(false);
                    setHeightMobile(`calc(50px + ${childrenH}px)`);
                  } else {
                    setInfo(false);
                    setHeightMobile(`50px`)
                  }
                  
                }}
              >
                <SvgIcon
                    viewBox={"0 0 101 92"}
                    sx={{ width: 101, height: 92 }}
                    fontSize={"small"}
                  >
                    <MarmoRealLogoTondo />
                  </SvgIcon>
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems:"center"
                }}
                onClick={() => {
                  let children = refInnerBottomMenu.current.offsetHeight;
                  if (!showMenu) {
                    setMenu(true);
                    setInfo(false);
                    setHeightMobile(`calc(50px + ${children}px)`);
                  } else {
                    setMenu(false);
                    setHeightMobile("50px");
                  }
                }}
              >
                <PulsanteMenu />
              </div>
            </div>

            {<div
              className="hiddendiv"
              ref={refInnerBottomBar}
              style={{
                position:"fixed",
                bottom:"0px",
                left:"0px",
                visibility: !showInfo ?  "hidden" : "visible",
                width: "100%",
                padding: "0px 6.21vw"
              }}
            >
            
              <BoxContainer
                visible={false}
                position={{
                    bottom: "0", left: "0",
                    visibility: showInfo ? "visible" : "hidden",
                    position: "static",
                    width: "100%",
                    padding:"16px 0px",
                    gap: "16px",
                    border: "0px",
                    borderTop: "2px solid #00A4B7",
                    borderRadius: "0px"
                }}
                titleBox={"Block info"}
                titleDescription={["Model name:", "Material:", "Dimensions:"]}
                description={[props.modelName, props.material, props.dimension, props.dimInch]}
                asInfoBlock={true}
              />
            </div>}

            <div
              className="hiddendivmenu"
              ref={refInnerBottomMenu}
              style={{
                position:"fixed",
                bottom:"0px",
                left:"0px",
                visibility: showMenu ? "visible" : "hidden",
                width: "100%",
                padding: "0px 6.21vw",

              }}
            >
              <div
                style={{
                  display:"flex",
                  flexDirection:"column",
                  gap:"16px",
                  padding: "16px 0px",
                  borderTop: "2px solid #00A4B7"
                }}
              >
                <div style={{fontWeight:600, fontSize: "20px", color: "#a3d8e7"}}>Tools</div>
                <div
                  style={{
                    display:"flex",
                    flexDirection:"row",
                    justifyContent:"space-between",
                    gap: "8px"
                  }}
                >

                  <SquareButtonMobile
                      onClick={() => {checkEnableFreeDraw(); setMenu(false); setHeightMobile("50px") } }
                      state={freeDraw}
                      iconOff={<PulsanteDrawOff />}
                      iconOn={<PulsanteDrawOn />}
                      text={"Draw"}
                  />

                  <SquareButtonMobile
                      onClick={() => {checkEnableMeasure(); setMenu(false); setHeightMobile("50px")}}
                      state={measure}
                      iconOff={<PulsanteRulerOff />}
                      iconOn={<PulsanteRulerOn />}
                      text={"Ruler"}
                  />

                  <SquareButtonMobile
                      onClick={() => {makeScreenShot(); setMenu(false); setHeightMobile("50px")}}
                      iconOff={<PulsanteScreenOff />}
                      iconOn={<PulsanteScreenOff />}
                      text={"Screenshot"}
                      state={false}
                  />

                </div>
              </div>
            </div>
  
          </BottomBar>
        </>
      )}
    </>
  ) : (
    <>
        <LottieInitAnimation play={myState==false}/>  
    </>
  );
}
